import { FormEvent, useState } from "react";
import { Toaster } from "react-hot-toast";
import { Link, useParams } from "react-router-dom";
import Button from "../../../components/Button";
import IconButton from "../../../components/IconButton";
import { InputV3 } from "../../../components/InputV3";
import { toastError } from "../../../components/Toast";
import useAuthData from "../../../hook/useAppData";
import { IconEye, IconEyeOutline, IconKey, IconLeftArrowVersion2 } from "../../../icons";
import { isPasswordValid } from "../../../libs/validationPassaword";
import { postResetPassword } from "../../../page/auth/service/service";
import { BodyAuthComponents } from "../components/BodyAuth";
import { SuccessReset } from "./success";

type ResetPasswordControl = {
  password: string;
  confirmPassword: string;
};

export function ResetPassword(hash) {
  const { setToken } = useAuthData();
  const params = useParams<{ hash: string }>();
  const [error, setError] = useState<{ password: string; confirmPassword: string }>({
    password: undefined,
    confirmPassword: undefined,
  });
  const [value, setValue] = useState<ResetPasswordControl>({
    password: "",
    confirmPassword: "",
  });
  const [page, setPage] = useState<"reset" | "successReset">("reset");
  const [hiddenPassword, setHiddenPassword] = useState(true);
  const [hiddenConfirmPassword, setHiddenConfirmPassword] = useState(true);

  async function handleSubmitResetPassword(event: FormEvent) {
    event.preventDefault();
    if (verefyFieldsIfHasError()) return;

    const data = {
      hash: params.hash,
      password: value?.password,
    };

    const saveNewPassword = await postResetPassword(data);
    if (saveNewPassword?.ok) {
      return setPage("successReset");
    }
    return toastError("Erro ao cadastrar, verifique seus dados e tente novamente em alguns instantes");
  }

  const verefyFieldsIfHasError = () => {
    const passwordValid = isPasswordValid(value.password).validationPassword();
    const passwordVerify = value?.password === value?.confirmPassword;
    let errors = 0;
    if (!passwordValid.isValid) errors += 1;
    if (!passwordVerify) errors += 1;

    setError({
      password: !value.password ? "Campo obrigatório!" : !passwordValid.isValid ? passwordValid.message : undefined,
      confirmPassword: !value.confirmPassword ? "Campo obrigatório!" : undefined,
    });

    return errors ? true : false;
  };

  return (
    <>
      <Toaster />
      <BodyAuthComponents className="flex flex-col justify-center items-center gap-12">
        {page === "reset" && (
          <>
            <div className="flex flex-col items-center w-3/5 sm:w-4/5">
              <IconButton icon={IconKey} className="icon-recoverPassword" />
              <div className="box-icon-key flex justify-center items-center"></div>
              <div className="box-pulse flex justify-center items-center"></div>
              <h1 className="text-5xl font-semibold">Defina uma nova senha</h1>
              <p className="text-1.6rem mt-5 text-textPrimary text-center">Sua nova senha deve ser diferente da senha anterior.</p>
            </div>
            <form onSubmit={handleSubmitResetPassword} className="w-full flex flex-col items-center gap-12">
              <div className="flex flex-col items-center w-3/5 sm:w-4/5 gap-4">
                <InputV3
                  inputProps={{
                    placeholder: "Defina uma senha",
                    autoFocus: true,
                    value: value?.password,
                    onChange: (e) => setValue({ ...value, password: e.target.value }),
                    type: hiddenPassword ? "password" : "text",
                  }}
                  labelProps={{
                    children: "Digite sua nova senha",
                  }}
                  iconButtonProps={{ icon: hiddenPassword ? IconEyeOutline : IconEye, onClick: () => setHiddenPassword((oldValue) => !oldValue) }}
                  errorStatus={error.password ? true : false}
                  errorMessage={error.password}
                />
                <InputV3
                  inputProps={{
                    placeholder: "Defina uma senha",
                    autoFocus: true,
                    value: value?.confirmPassword,
                    onChange: (e) => {
                      if (value?.password !== e.target.value) setError({ ...error, confirmPassword: "Senhas não conferem!" });
                      else setError({ ...error, confirmPassword: undefined });
                      setValue({ ...value, confirmPassword: e.target.value });
                    },
                    type: hiddenConfirmPassword ? "password" : "text",
                  }}
                  labelProps={{
                    children: "Confirme sua nova senha",
                  }}
                  iconButtonProps={{
                    icon: hiddenConfirmPassword ? IconEyeOutline : IconEye,
                    onClick: () => setHiddenConfirmPassword((oldValue) => !oldValue),
                  }}
                  errorStatus={error.confirmPassword ? true : false}
                  errorMessage={error.confirmPassword}
                />
              </div>
              <div className="flex flex-col items-center w-3/5 sm:w-4/5 gap-4 px-4">
                <Button type="submit" className="bg-primary w-full rounded-xl">
                  Confirmar sua nova senha
                </Button>
                <span className="text-lg mt-3 text-textPrimary">
                  <Link to="/login" className="w-full h-full">
                    <Button className="w-full text-textPrimary hover:bg-gray-100 rounded-xl">
                      <IconButton className="icon-back-login" icon={IconLeftArrowVersion2} /> Voltar para login
                    </Button>
                  </Link>
                </span>
              </div>
            </form>
          </>
        )}
        {page === "successReset" && (
          <>
            <SuccessReset />
          </>
        )}
      </BodyAuthComponents>
    </>
  );
}
